import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import Drawer from 'react-motion-drawer'
import Navbar from './components/Navbar'
import GameSpace from './components/GameSpace'

class App extends Component {

    state = {
        drawerOpen: true,
    }

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.setState({
            drawerOpen: true
        })
    }

    onChange = e => {
        this.setState({
            drawerOpen: !this.state.drawerOpen
        })
    }

    render() {
        return (
            <div className="App">
                <Navbar />
                <div className='gamespace'>
                    <GameSpace />
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js